<template>
  <button
    class="checkbox"
    :class="{'checkbox--active': value}"
    type="button"
    @click.stop="toggleCheck"
  >
    <div class="checkbox__icon">
      <div class="checkbox__placeholder">
        <CheckSVG />
      </div>
    </div>

    <span v-if="$slots.default">
      <slot />
    </span>
  </button>
</template>

<script>
import CheckSVG from '@/components/svg/CheckSVG'

export default {
  props: ['value'],

  components: {
    CheckSVG,
  },

  methods: {
    toggleCheck () {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/variables";

  .checkbox {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    cursor: pointer;
    text-align: left;;

    &__icon {
      flex: 0 0 auto;
      display: inline-flex;
      align-items: stretch;
      width: 22px;
      height: 22px;
      border: 2px solid $fucsia300;
      border-radius: 3px;
    }

    &__placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      background: $fucsia300;
      opacity: 0;
    }

    &--active &__placeholder {
      opacity: 1;
    }
  }
</style>